import { errorCellRenderer } from "../components/flowTable";
import { FlowTableColumn } from "../components/flowTable/types";

export const asnColumns: FlowTableColumn[] = [
  { data: "nome_asn", header: "Nome", type: "text", width: 240 },
  { data: "asn", header: "ASN", type: "text", width: 160 },
];

export const asnMassColumns: FlowTableColumn[] = asnColumns.map((column) => ({
  ...column,
  renderer: errorCellRenderer,
}));
